import { Translations } from './en';

const fr: Translations = {
  auth: {
    signingIn: "Vérification de l'état de connexion...",
    loading: 'Chargement...',
    signInButton: 'Se connecter',
    inactivityError: "Vous avez été déconnecté pour cause d'inactivité. Veuillez vous reconnecter",
  },
  certificationTest: {
    retakeCertificationTestTitle: 'Repasser une certification',
    retakeCertificationTestDescription:
      'Vous êtes sur le point de repasser une certification, votre ancienne note sera effacée, êtes vous sur ?',
  },
  certifications: {
    subtitle: 'Obtenez des certifications pour débloquer des projets',
    table: {
      completionDate: 'Date de réalisation',
      numberOfQuestions: 'Nombre de questions',
      mark: 'Note',
      actions: 'Actions',
    },
  },
  certification: {
    passedOn: 'Passé le {{date}}',
    table: {
      questionId: 'ID Question',
      duration: 'Temps de passage',
      score: 'Score',
    },
  },
  contributions: {
    title: 'Mes contributions',
    table: {
      projectName: 'Nom du projet',
    },
  },
  contribution: {
    subtitle: 'Voici l’historique de votre activité',
    table: {
      hit: 'Traitement',
    },
  },
  errorPage: {
    unknownError: 'Erreur inconnue',
    notFound: 'Erreur 404 : page introuvable',
  },
  navigation: {
    projects: 'Projets',
    certifications: 'Certifications',
    contributions: 'Contributions',
    informations: 'Informations',
  },
  notifications: {
    error: 'Oups...',
    success: 'Succès !',
    requestIsProcessing: 'Votre demande est en cours de traitement',
    defaultErrorDescription: 'Erreur',
    user: {
      success: {
        description: "L'utilisateur a été mis à jour avec succès.",
      },
      error: {
        description: "Une erreur est survenue lors de la mise à jour de l'utilisateur.",
      },
    },
  },
  projects: {
    subtitle: 'Voici votre tableau de bord',
    displayModes: {
      cards: 'Cartes',
      list: 'Liste',
    },
    contribute: 'Contribuer',
  },
  user: {
    title: 'Mes informations',
    profileDescription: 'Ces informations seront affichées sur votre profil.',
    saveChanges: 'Enregistrer les modifications',
    general: {
      title: 'Général',
      id: 'ID',
      email: 'Email',
      phone: 'Téléphone',
      firstName: 'Prénom',
      lastName: 'Nom',
      birthDate: 'Date de naissance',
      nationality: 'Nationalité',
    },
    avatar: {
      title: 'Votre avatar',
      description: 'Il sera affiché à côté de votre nom',
    },
    sociodemographic: {
      title: 'Socio-démographique',
      earning: 'Niveau de revenu',
      study: 'Études',
      family: 'Situation familiale',
      children: 'Nombre d’enfants',
      job: 'Profession',
      activitySector: 'Secteur d’activité',
    },
    address: {
      address: 'Adresse',
      zipCode: 'Code postal',
      city: 'Ville',
      region: 'Région',
      country: 'Pays',
    },
    logout: {
      label: 'Se déconnecter',
      description: 'Fermez votre session sur cet appareil.',
    },
  },
};

export default fr;
